import React from "react";
import { cn } from "@/lib/utils";
import engineTurbineBase from "@/assets/engine-turbine-base.png";

interface EngineAssetIconProps {
  className?: string;
  /** Whether the icon should be inverted (white) - typically when on dark/active backgrounds */
  inverted?: boolean;
}

/**
 * A simple engine turbine icon for use in asset type selectors/toggles.
 * This is the small icon version, NOT the full EngineIcon with symbols.
 */
export const EngineAssetIcon: React.FC<EngineAssetIconProps> = ({
  className,
  inverted = false,
}) => {
  return (
    <img
      src={engineTurbineBase}
      alt="Engine"
      className={cn(
        "object-contain",
        inverted ? "brightness-0 invert" : "brightness-0 dark:invert",
        className
      )}
    />
  );
};
